import UserApartmentsList from './UserApartmentsList';

export default UserApartmentsList;
